import Icon from '../components/Icon.vue'

Icon.register({"thermometer":{"width":512,"height":512,"paths":[{"d":"M476.8 20.4C439.3-10.3 381.3-5.9 344.9 30.6L299.2 76.6 349.7 127.1C352.8 130.2 352.8 135.3 349.7 138.4L338.4 149.7C335.3 152.8 330.2 152.8 327.1 149.7L276.7 99.2 231.6 144.6 281.9 195C285 198.1 285 203.2 281.9 206.3L270.6 217.6C267.5 220.7 262.4 220.7 259.3 217.6L209 167.4 163.9 212.8 214 263C217.1 266.1 217.1 271.2 214 274.3L202.7 285.6C199.6 288.7 194.5 288.7 191.4 285.6L141.3 235.4 96 281.1V382L7 471C-2.4 480.4-2.4 495.6 7 504.9 16.4 514.3 31.6 514.3 40.9 504.9L129.9 415.9H229.8L484 162.6C518.9 127.7 526.2 61.1 476.8 20.4z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/thermometer.js
// module id = FAYN
// module chunks = 0